import { useEffect, useState, useMemo } from 'react';
import { CART_EXPIRES_IN_TEN_SECONDS, CART_EXPIRES_IN_ONE_MINUTE, CART_EXPIRES_IN_FIVE_MINUTES, } from './constants';
import { getNow } from './lib/helpers';
const noop = () => { };
export const useTimer = (cart, options = {}) => {
    const { onCartExpiresFirstWarning = noop, onCartExpiresSecondWarning = noop, onCartExpiresLastWarning = noop, onCartExpired = noop, ExpiresFirstWarningSecondsLeft = CART_EXPIRES_IN_FIVE_MINUTES, ExpiresSecondWarningSecondsLeft = CART_EXPIRES_IN_ONE_MINUTE, ExpiresLastWarningSecondsLeft = CART_EXPIRES_IN_TEN_SECONDS, getNowInSeconds = getNow, } = options;
    const nowInSeconds = getNowInSeconds();
    const expiresAt = (cart && cart.expiresAt) || nowInSeconds;
    const [now, setNow] = useState(nowInSeconds);
    const counter = useMemo(() => Math.max(0, expiresAt - now), [expiresAt, now]);
    let intervalId;
    useEffect(() => {
        switch (counter) {
            case ExpiresFirstWarningSecondsLeft:
                onCartExpiresFirstWarning();
                break;
            case ExpiresSecondWarningSecondsLeft:
                onCartExpiresSecondWarning();
                break;
            case ExpiresLastWarningSecondsLeft:
                onCartExpiresLastWarning();
                break;
            case 0:
                onCartExpired();
                break;
            default:
                break;
        }
    }, [counter]);
    useEffect(() => {
        intervalId = setInterval(() => {
            setNow(getNowInSeconds());
        }, 1000);
        return () => {
            clearInterval(intervalId);
        };
    }, []);
    return { counter };
};
//# sourceMappingURL=hooks.js.map